import { NotificationComponent } from "./ui/index.jsx"
import selectors from "./services/selectors.es6"
import { creators } from "./services/actions.js"
import { sagas } from "./services/sagas.js"

export const NotificationsV1 = {
  ui: NotificationComponent,
  selectors,
  actions: creators,
  sagas
}
